export const SITESETUP_GET_SITE_DETAILS = 'SITESETUP_GET_SITE_DETAILS';
export const SITESETUP_GET_SITE_DETAILS_ERROR =
  'SITESETUP_GET_SITE_DETAILS_ERROR';
export const SITESETUP_CLEAR_SITE_DETAILS = 'SITESETUP_CLEAR_SITE_DETAILS';
export const SITESETUP_UPDATE_SITE_DETAILS = 'SITESETUP_UPDATE_SITE_DETAILS';
export const SITESETUP_SITE_DETAILS_FETCHING =
  'SITESETUP_SITE_DETAILS_FETCHING';
export const GET_STORAGE_LOCATION = 'GET_STORAGE_LOCATION';
export const GET_HANDLING_FEE = 'GET_HANDLING_FEE';



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/siteDetails/types.js